import React, { useState, useRef } from 'react';
import { Tooltip } from '@mui/material';

const OverflowTooltip = ({ children, title, placement = 'top' }) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const elementRef = useRef(null);

  const checkOverflow = textElement => {
    if (!textElement) return false;

    // 기본 overflow 체크
    const hasScrollOverflow = textElement.scrollWidth > textElement.clientWidth;

    // ellipsis 스타일이 적용된 경우 추가 체크
    const computedStyle = getComputedStyle(textElement);
    const hasEllipsisStyle = computedStyle.textOverflow === 'ellipsis';
    const hasOverflowHidden = computedStyle.overflow === 'hidden';
    const hasWhiteSpaceNowrap = computedStyle.whiteSpace === 'nowrap';

    // ellipsis 조건이 모두 만족되고 실제로 overflow된 경우만 overflow로 간주
    const isEllipsisReady = hasEllipsisStyle && hasOverflowHidden && hasWhiteSpaceNowrap;
    const hasEllipsisOverflow = isEllipsisReady && textElement.scrollWidth > textElement.clientWidth;

    return hasScrollOverflow || hasEllipsisOverflow;
  };

  const handleMouseEnter = e => {
    // name 셀의 경우 특별한 클래스를 가진 div를 찾음
    const nameTextElement = e.currentTarget.querySelector('.staff-name-text');
    const textElement = nameTextElement || e.currentTarget.querySelector('div');
    setIsOverflowed(checkOverflow(textElement));
  };

  const handleMouseLeave = () => {
    setIsOverflowed(false);
  };

  const handleMouseMove = e => {
    // name 셀의 경우 특별한 클래스를 가진 div를 찾음
    const nameTextElement = e.currentTarget.querySelector('.staff-name-text');
    const textElement = nameTextElement || e.currentTarget.querySelector('div');
    setIsOverflowed(checkOverflow(textElement));
  };

  return (
    <div ref={elementRef} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onMouseMove={handleMouseMove}>
      {isOverflowed ? (
        <Tooltip
          title={title}
          placement={placement}
          arrow
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: '#2D2D2D !important',
                opacity: '1 !important',
                color: 'var(--Text-Inverse, #FFF) !important',
                fontFamily: 'var(--Font-family-font, Pretendard) !important',
                fontSize: 'var(--Size-Caption-Small, 15px) !important',
                fontStyle: 'normal !important',
                fontWeight: '400 !important',
                lineHeight: '150% !important',
                letterSpacing: '-0.15px !important',
                padding: '8px 12px !important',
                borderRadius: '4px !important',
                boxShadow: '0 0 2px 0 rgba(0, 0, 0, 0.04), 0 -2px 8px 0 rgba(0, 0, 0, 0.04), 0 -8px 24px 0 rgba(0, 0, 0, 0.08) !important',
              },
            },
            arrow: {
              sx: {
                color: '#2D2D2D !important',
              },
            },
          }}
        >
          {children}
        </Tooltip>
      ) : (
        children
      )}
    </div>
  );
};

export default OverflowTooltip;
